import { useState, useEffect } from "react";
import logo from "../images/amacsport.jpg";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/AuthContext";
import { useSelector } from "react-redux";

const HeaderHome = () => {
  const [isSticky, setIsSticky] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const navigate = useNavigate();
  const { logout: contextLogout } = useAuth();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsSticky(true);
        setIsVisible(false);
      } else {
        setIsSticky(false);
        setIsVisible(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleLogout = () => {
    navigate("/");
    contextLogout();
  };

  return (
    <div className={`w-screen bg-[#1F1E2E] transition-all duration-300 fixed top-0 left-0 right-0 z-50`}>
      <nav className="flex justify-center relative items-center px-5 py-8 text-white">
        <a className="text-3xl font-bold absolute left-6" href="#">
          <img className="h-9" src={logo} alt="Logo" />
        </a>
        <ul
          className={`hidden md:flex space-x-12 font-semibold ${
            isVisible ? "opacity-100" : "opacity-0"
          } transition-opacity duration-300`}
        >
          <li>
            <a
              className="hover:text-gray-200 cursor-pointer"
              onClick={() => navigate("/ranking")}
            >
              Bảng Xếp Hạng
            </a>
          </li>
          <li>
            <a
              className="hover:text-gray-200 cursor-pointer"
              onClick={() => navigate("/user-management")}
            >
              Quản Lý Người Dùng
            </a>
          </li>
          <li>
            <a
              className="hover:text-gray-200 cursor-pointer"
              onClick={() => navigate("/post-approval")}
            >
              Xét Duyệt Bài Đăng
            </a>
          </li>
          <li>
            <a
              className="hover:text-gray-200 cursor-pointer"
              onClick={() => navigate("/post-code-manage")}
            >
              Quản Lý Mã
            </a>
          </li>
          <li>
            <a
              className="hover:text-gray-200 cursor-pointer"
              onClick={() => navigate("/week-config")}
            >
              Quản Lý Danh Sách Tuần
            </a>
          </li>
          <li>
            <a
              className="hover:text-gray-200 cursor-pointer"
              onClick={() => navigate("/create-achie")}
            >
              Tạo Giải Thưởng
            </a>
          </li>
          {/* <li>
            <a
              className="hover:text-gray-200 cursor-pointer"
              onClick={() => navigate("/date-config")}
            >
              Thời Gian Đăng Bài
            </a>
          </li>
          <li>
            <a
              className="hover:text-gray-200 cursor-pointer"
              onClick={() => navigate("/admin-post")}
            >
              Bài đăng Admin
            </a>
          </li> */}
        </ul>
        <div className="flex items-center absolute right-6 space-x-4 ml-4 mr-6">
          <button
            className="px-4 py-2 bg-blue-700 text-white rounded-lg transition duration-300 hover:bg-blue-600"
            onClick={handleLogout}
          >
            Đăng Xuất
          </button>
        </div>
      </nav>
    </div>
  );
};

export default HeaderHome;
